import makeStyles from "@mui/styles/makeStyles";
import { Box, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useContext } from "react";

import { CognitoAuthContext } from "components/Authentication/CognitoAuthContext";
import { styles } from "assets/jss/default/views/errorPageStyles";
import { useTrackPageView } from "hooks/useTrackPageView";
import { useVersionCheckQuery } from "hooks/queries/useVersionCheckQuery";
import { siteSettings } from "core/siteSettings";

const useStyles = makeStyles(styles);

function DownForMaintenance() {
  const { error, logout, user } = useContext(CognitoAuthContext);

  useTrackPageView("Maintenace");
  const classes = useStyles();

  const {
    isError: isVersionError,
    error: versionError,
    data: versionResponse
  } = useVersionCheckQuery();

  return (
    <>
      <div className={classes.contentCenter}>
        <Stack spacing={2}>
          <h1 className={classes.title}>New Version Released</h1>
          <Box>
            <Typography>
              Press <Kbd>Ctrl</Kbd> + <Kbd>Shift</Kbd> + <Kbd>R</Kbd> to refresh
              and click here to{" "}
              <a className={classes.link} href="/">
                return to the homepage
              </a>
            </Typography>
          </Box>

          <Box>
            <StyledButton onClick={() => logout()}>Logout</StyledButton>
          </Box>

          <div className={classes.root}>
            <Typography className={classes.margin}></Typography>
          </div>

          <Box sx={{ textAlign: "left" }}>
            <Details>
              <Typography component="summary">Details</Typography>
              <Typography sx={{ marginTop: 2 }} variant="h4" component="h2">
                Version Check
              </Typography>

              <Typography sx={{ marginTop: 2 }} variant="h6" component="h3">
                Version Check
              </Typography>
              <Typography>
                Backend: {versionResponse?.version ?? "Unknown"}
              </Typography>
              <Typography>
                Frontend: {siteSettings.frontEndVersion ?? "Unknown"}
              </Typography>

              {isVersionError && (
                <>
                  <Typography sx={{ marginTop: 2 }} variant="h6" component="h3">
                    Error Message
                  </Typography>
                  <Typography>{versionError.message}</Typography>

                  <Typography sx={{ marginTop: 2 }} variant="h6" component="h3">
                    Trace
                  </Typography>
                  <Pre>{JSON.stringify(versionError, null, 2)}</Pre>
                </>
              )}

              <Typography sx={{ marginTop: 2 }} variant="h4" component="h2">
                Authentication
              </Typography>

              <Typography sx={{ marginTop: 2 }} variant="h6" component="h3">
                Auth Error
              </Typography>
              <Pre>{JSON.stringify(error, null, 2)}</Pre>

              <Typography sx={{ marginTop: 2 }} variant="h6" component="h3">
                User
              </Typography>
              <Pre>{JSON.stringify(user, null, 2)}</Pre>
            </Details>
          </Box>
        </Stack>
      </div>
    </>
  );
}

const Kbd = styled("kbd")`
  background-color: #f7f7f7;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-shadow: inset 0 -1px 0 #ccc;
  color: #333;
  display: inline-block;
  line-height: 1;
  padding: 2px 4px;
  white-space: nowrap;
`;
Kbd.displayName = "StyledKbd";

const Details = styled("details")`
  background-color: #696969;
  padding: 0.5rem 1rem;

  > summary {
    cursor: pointer;
  }
`;
Details.displayName = "StyledDetails";

const Pre = styled("pre")`
  border: 1px solid white;
  color: white;
  max-height: 200px;
  overflow: auto;
  padding: 1;
  white-space: pre-wrap;
  margin: 0;
  padding: 10px;
`;
Pre.displayName = "StyledPre";

const StyledButton = styled("button")`
  background-color: #f7f7f7;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: inset 0 -1px 0 #ccc;
  color: #333;
  display: inline-block;
  line-height: 1;
  padding: 0.25rem 1rem;
  white-space: nowrap;
  font-size: 1.1rem;
  cursor: pointer;
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
`;
StyledButton.displayName = "StyledButton";

DownForMaintenance.propTypes = {};

export default DownForMaintenance;
